<template>
    <div class="loginContent">
        <div class="loginHead" v-if="isLoading">{{ projectLoginName }}</div>
        <div class="loginMain">
            <div class="formContent">
                <img class="fromImg" :src="logoMainUrl" alt="" v-if="isLoading"
                     :style="projectCode ? {'width':logoMainWidth} : {'width':'3rem'}">
                <div class="formMain">
                    <form class="fromBox" method="post">
                        <div class="fromItem">
                            <img class="itemImg" src="../assets/image/person.png" alt="">
                            <el-input type="text" placeholder="请输入用户名" v-model="form.username"></el-input>
                        </div>
                        <div class="fromItem">
                            <img class="itemImg" src="../assets/image/password.png" alt="">
                            <el-input type="password" placeholder="请输入密码" v-model="form.password"></el-input>
                        </div>
                        <div class="codeItem">
                            <div class="codeInput">
                                <img class="itemImg" src="../assets/image/safe.png" alt="">
                                <el-input type="text" placeholder="验证码" v-model="form.code"></el-input>
                            </div>
                            <div class="login_verification_image" @click="changeCode()">
                                <img id="code" alt="图片异常"/>
                            </div>

                        </div>
                        <div class="checkItem">
                            <el-checkbox v-model="checked" style="color:#66d9ef;">一周内自动登录</el-checkbox>
                        </div>
                        <el-button class="buttonItem" :loading="loadingLogin" @click="submitForm($event)"
                                   type="primary">登录
                        </el-button>
                    </form>
                </div>
            </div>


            <div
                class="company_introduction"
                v-if="(copyrightSwitch == undefined || copyrightSwitch != 0) && projectCode == 'JLJZY'"
            >
                <span class="introduction_text">沈阳晨飞建设工程项目管理咨询有限公司</span>
            </div>
            <div class="scit_introduction" v-else-if="copyrightSwitch == undefined || copyrightSwitch != 0">
                <span class="introduction_text">四川升拓检测技术股份有限公司</span>
                <br>
                <span class="text_English">Sichuan Central Inspection Technology Inc.</span>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import logoUrl from "../assets/image/logo.png";

export default {
    data() {
        return {
            projectLoginName: "智慧监测系统",
            logoMainUrl: logoUrl,
            form: {
                username: "",
                password: "",
                code: "",
            },
            checked: false,
            loadingLogin: false,
            isLoading: false,
            copyrightSwitch: null,
            projectCode: null,
            logoMainWidth: "5rem"
        }
    },
    mounted() {
        this.projectCode = this.$getUrlParams("projectCode")
        localStorage.setItem("projectCode", this.$getUrlParams("projectCode"))
        if (localStorage.getItem("projectCode")) {
            this.getProjectInfo()
        } else {
            this.isLoading = true
        }

        var docEl = document.documentElement;

        function reSetRem() {
            let w = docEl.clientWidth;
            var radio = w / 1920;//这里值设置成设计稿对应的屏幕宽度
            var rem = radio * 100 //值为初始化root font-size
            // console.log(docEl.style.fontSize,222)
            docEl.style.fontSize = rem + "px"
        }

        window.addEventListener("resize", reSetRem);
        reSetRem();

        this.getCookie();
        // $('#code').attr("src", "api/monitor-guiyang/CheckCode/code?" + new Date()); // 每次进入页面初始化验证码
        $("#code").attr("src", "api/monitor/CheckCode/code?" + new Date()); // 每次进入页面初始化验证码

      if(this.projectCode==="GNFDT"){
        const loading = this.$loading({
          lock: true,
          text: '登录中,请耐心等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.loadingLogin = true
        this.form={username: "GNFDT", password: "123456", code: "",},
        this.$axios.post("api/auth/auth/login", this.form).then(res => {
          const login_code = res.data.status;
          if (login_code !== 200) {
            this.$message({
              message: res.data.message,
              type: "warning",
              // duration:80000
            });
            this.loadingLogin = false
            loading.close();
            return
          }
          // 判断复选框是否被勾选 勾选则调用配置cookie方法
          if (this.checked == true) {
            // 传入账号名，密码，和保存天数3个参数
            this.setCookie(this.form.username, this.form.password, 7);
          } else {
            // 未勾选，清除cookie
            this.clearCookie();
          }
          const token = res.data.datas.values;
          localStorage.setItem("token", token);
          localStorage.setItem("username", this.form.username);
          // return;
          this.$axios.get("api/monitor/index/checkExistProject").then(res => {
            if (res.data.status == 200) {
              loading.close();
              this.loadingLogin = false
              this.$router.push({ name: "ProjectChoose" })
            } else {
              loading.close();
              this.loadingLogin = false
              sessionStorage.setItem("cursor", "4")
              sessionStorage.setItem("isSelect", "menu5")
              localStorage.setItem("systemType", "2")
              localStorage.setItem("path", "")
              this.$router.push({ name: "ProjectInfo" })
            }
            return
          }).catch(() => {
            loading.close();
            this.loadingLogin = false
          })
        }).catch(() => {
          loading.close();
          this.loadingLogin = false
        })
      }

    },
    methods: {
        getProjectInfo() {
            this.$axios.get("api/monitor/anonymous/channelInfo", {
                params: {
                    channelCode: localStorage.getItem("projectCode")
                }
            }).then(res => {
                this.isLoading = true
                let data = res.data
                if (data.datas) {
                    if (data.datas.values) {
                        let values = data.datas.values
                        this.logoMainUrl = values.logoMainUrl
                        this.projectLoginName = values.projectLoginName
                        this.copyrightSwitch = values.copyrightSwitch
                        let string = values.extJsonInfo
                        if (string) {
                            let obj = JSON.parse(string)
                            if (obj.logoMainWidth) {
                                this.logoMainWidth = obj.logoMainWidth / 100 + "rem"
                            }
                        }
                    }
                }
            }).catch(() => {

            })
        },
        changeCode() {
            // $('#code').attr("src", "api/monitor-guiyang/CheckCode/code?" + new Date());
            $("#code").attr("src", "api/monitor/CheckCode/code?" + new Date());
        },
        //设置cookie
        setCookie(c_name, c_pwd, exdays) {
            var exdate = new Date(); // 获取时间
            exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); // 保存的天数
            //字符串拼接cookie
            window.document.cookie = "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
            window.document.cookie = "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
        },
        //读取cookie
        getCookie: function() {
            if (document.cookie.length > 0) {
                this.checked = true; // 如果有cookie,就勾选checked
                var arr = document.cookie.split("; ");  // 这里显示的格式需要切割一下自己可输出看下
                for (var i = 0; i < arr.length; i++) {
                    var arr2 = arr[i].split("="); // 再次切割
                    // 判断查找相对应的值
                    if (arr2[0] == "userName") {
                        this.form.username = arr2[1]; // 保存到保存数据的地方
                    } else if (arr2[0] == "userPwd") {
                        this.form.password = arr2[1];
                    }
                }
            }
            // console.log(this.form,111)
        },
        submitForm: function(event) {
            event.preventDefault();
            this.loadingLogin = true
            this.$axios.post("api/auth/auth/login", this.form).then(res => {
                const login_code = res.data.status;
                if (login_code !== 200) {
                    this.$message({
                        message: res.data.message,
                        type: "warning",
                        // duration:80000
                    });
                    this.loadingLogin = false

                    return
                }
                // 判断复选框是否被勾选 勾选则调用配置cookie方法
                if (this.checked == true) {
                    // 传入账号名，密码，和保存天数3个参数
                    this.setCookie(this.form.username, this.form.password, 7);
                } else {
                    // 未勾选，清除cookie
                    this.clearCookie();
                }
                const token = res.data.datas.values;
                localStorage.setItem("token", token);
                localStorage.setItem("username", this.form.username);
                this.$axios.get("api/monitor/index/checkExistProject").then(res => {
                    if (res.data.status == 200) {
                        this.loadingLogin = false
                        this.$router.push({ name: "ProjectChoose" })
                    } else {
                        this.loadingLogin = false
                        sessionStorage.setItem("cursor", "4")
                        sessionStorage.setItem("isSelect", "menu5")
                        localStorage.setItem("systemType", "2")
                        localStorage.setItem("path", "")
                        this.$router.push({ name: "ProjectInfo" })
                    }
                    return
                }).catch(() => {
                    this.loadingLogin = false
                })
            }).catch(() => {
                this.loadingLogin = false
            })
        },
        clearCookie: function() {
            this.setCookie("", "", -1); //修改两值都为空，天数为负1天
        }
    }
}
</script>

<style scoped>

.loginContent {
    position: fixed;
    height: 100%;
    width: 100%;
    /*min-width: 1024px;*/
    /*min-height: 768px;*/
    background-image: url("../assets/image/monitor_bg.png");
    background-size: cover;
    background-position: center center;
}

.loginHead {
    height: 7%;
    width: 100%;
    background-image: url("../assets/homeimg/banner.png");
    background-size: cover;
    background-position: center center;
    font-size: 0.32rem;
    font-weight: bold;
    color: #FFFFFF;
    letter-spacing: 0.05rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.loginMain {
    height: 93%;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
}

.formContent {
    /*border: 1px solid red;*/
    min-width: 300px;
    min-height: 280px;
    width: 5rem;
    height: 4.8rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.fromImg {
    width: 100%;
//height: 0.32rem;
}

.formMain {
    width: 100%;
    height: 90%;
    background-image: url("../assets/image/login_form.png");
    background-size: 100% 100%;
    background-position: center top;
    background-repeat: no-repeat;
}

.fromBox {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.fromBox .fromItem:nth-of-type(1) {
    margin-top: 0;
}

.fromItem {
    width: 80%;
    height: 12%;
    margin: 2% 0;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    border-radius: 5px;
    background-color: rgba(15, 58, 115, 0.5);
}

.itemImg {
    width: 20px;
    height: 20px;
    margin-left: 20px;
}

/deep/ .fromItem .el-input__inner {
    background: none;
    border: none;
    color: #ffffff;
    font-size: 0.16rem;;
}


/*验证码*/
.codeItem {
    height: 12%;
    margin: 2% 0;
    width: 80%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.codeInput {
    height: 80%;
    width: 50%;
    background-color: rgba(15, 58, 115, 0.5);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

/deep/ .codeInput .el-input__inner {
    width: 100%;
    background: none;
    border: none;
    color: #ffffff;
    font-size: 0.16rem;
}

.login_verification_image {
    /*border: 1px solid red;*/
    width: 45%;
    height: 80%;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: nowrap;
    font-size: 0.16rem;
    color: rgba(255, 255, 255, 0);
    cursor: pointer;
}

.login_verification_image > img {
    width: 80%;
    height: 100%;
}

/*记住登录*/
.checkItem {
    height: 5%;
    width: 74%;
    margin: 1% 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
}

/*登录*/
.buttonItem {
    width: 80%;
    height: 12%;
    margin: 2% 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    background-color: rgb(22, 83, 189);
    border: none;
    font-size: 0.22rem;
    font-weight: bold;
    letter-spacing: 0.1rem;
}


.scit_introduction {
    color: #fff;
    font: 0.24rem Microsoft YaHei;
    text-align: center;
    position: absolute;
    top: 90%;
}
.company_introduction{
  color: #fff;
  font: 0.24rem Microsoft YaHei;
  text-align: center;
  position: absolute;
  top: 80%;
}

.introduction_text {
    display: inline-block;
}

.text_English {
    display: inline-block;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue